import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import {
  addToCart,
  deleteFromCart,
  getCartItems,
  updateCart,
  emptyCart,
} from "../services/cartService";
import auth from "../services/authService";
import Footer from "./footer";
import Navbar from "./navbar";
import Home from "./home";
import ProductPage from "./productPage";
import Products from "./products";
import LoginPage from "./loginPage";
import SignupPage from "./signupPage";
import AddNewProduct from "./addNewProduct";
import Logout from "./logout";
import NotFound from "./notFound";
import Dashboard from "./dashboard";
import Profile from "./profile";
import UpdateProfile from "./updateProfile";
import UpdatePassword from "./updatePassword";
import Checkout from "./checkout";
import NotificationBar from "./Common/notificationBar";
import ProtectedRoute from "./Common/protectedRoute";
import ForgotPasswordPage from "./forgotPasswordPage";
import ResetPassword from "./resetPassword";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./stylesheet.css";
import OurStory from "./ourStory";

class Application extends Component {
  state = {
    products: [],
    cartItems: [],
    notify: "",
    cartopen: false,
    loading: true,
  };

  async componentDidMount() {
    const user = auth.getCurrentUser();
    this.setState({ user, cartItems: getCartItems() });

    console.log("HI", this.state.heroImageLoaded);

    const spinner = document.getElementById("spinner");
    if (spinner && !spinner.hasAttribute("hidden")) {
      setTimeout(() => spinner.setAttribute("hidden", "true"), 1500);
    }
    // setTimeout(() => this.setState({ loading: false }), 1500);

    // Check if the hero image is already loaded
    const heroImage = new Image();
    heroImage.src = "/img/product-mini.png";
    heroImage.style.display = "none";
    heroImage.style.backgroundColor = "red";
    heroImage.onload = () => {
      setTimeout(() => this.setState({ loading: false }), 1500);
    };
  }

  updateUser = () => {
    const user = auth.getCurrentUser();
    this.setState({ user });
  };

  handleNotification = (notify) => {
    this.setState({ notify });
    setTimeout(() => this.setState({ notify: "" }), 4000);
  };

  handleAddtoCart = (product, quantity) => {
    const cartItems = addToCart(product, quantity);
    let { cartopen } = this.state;
    cartopen = !cartopen;

    this.setState({ cartItems, cartopen });
  };

  deleteFromCart = (cartItem) => {
    const cartItems = deleteFromCart(cartItem);
    this.setState({ cartItems });
  };

  handleCartQuantity = (button, item) => {
    const cartItems = updateCart(button, item);
    this.setState({ cartItems });
  };

  emptyCart = () => {
    emptyCart();
    this.setState({ cartItems: [] });
  };

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    const { cartItems, user, notify, cartopen, loading } = this.state;
    if (loading) return null;

    return (
      <div>
        <Router>
          <Navbar
            user={user}
            cartItems={cartItems}
            deleteFromCart={this.deleteFromCart}
            handleCartQuantity={this.handleCartQuantity}
            cartopen={cartopen}
          />

          {notify && (
            <NotificationBar message={notify.message} img={notify.img} />
          )}

          <Switch>
            <ProtectedRoute
              path='/checkout'
              render={(props) => (
                <Checkout
                  {...props}
                  cartItems={cartItems}
                  handleNotification={this.handleNotification}
                  handleAddtoCart={this.handleAddtoCart}
                  emptyCart={this.emptyCart}
                />
              )}
            />

            {user && user.isAdmin && (
              <Route
                path='/add-new-product/:id?'
                render={(props) => (
                  <AddNewProduct
                    {...props}
                    handleNotification={this.handleNotification}
                  />
                )}
              />
            )}

            {/* <Route
              path='/forgot-password/'
              render={(props) => (
                <ForgotPassword
                  {...props}
                  handleNotification={this.handleNotification}
                />
              )}
            /> */}
            <Route
              path='/forgot-password/'
              render={(props) => (
                <ForgotPasswordPage
                  {...props}
                  handleNotification={this.handleNotification}
                />
              )}
            />

            {!user && (
              <Route
                path='/reset/:token'
                render={(props) => (
                  <ResetPassword
                    {...props}
                    handleNotification={this.handleNotification}
                  />
                )}
              />
            )}

            <Route
              path='/login/'
              render={(props) => {
                if (auth.getCurrentUser()) {
                  return <Redirect to='/dashboard' />;
                }
                return (
                  <LoginPage
                    {...props}
                    updateUser={this.updateUser}
                    handleNotification={this.handleNotification}
                  />
                );
              }}
            />

            <Route
              path='/signup/'
              render={(props) => {
                if (auth.getCurrentUser()) {
                  return <Redirect to='/dashboard' />;
                }
                return (
                  <SignupPage
                    {...props}
                    updateUser={this.updateUser}
                    handleNotification={this.handleNotification}
                  />
                );
              }}
            />

            {user && (
              <Route
                path='/logout'
                render={(props) => (
                  <Logout {...props} updateUser={this.updateUser} />
                )}
              />
            )}

            <ProtectedRoute
              path='/update-password/'
              render={(props) => (
                <UpdatePassword
                  {...props}
                  handleNotification={this.handleNotification}
                />
              )}
            />
            <ProtectedRoute
              path='/update-profile'
              render={(props) => (
                <UpdateProfile
                  {...props}
                  updateUser={this.updateUser}
                  handleNotification={this.handleNotification}
                />
              )}
            />
            <ProtectedRoute path='/profile' component={Profile} />
            <ProtectedRoute path='/dashboard' component={Dashboard} />

            <Route
              path='/products/product/:id'
              render={(props) => (
                <ProductPage
                  {...props}
                  handleNotification={this.handleNotification}
                  handleCart={this.handleAddtoCart}
                />
              )}
            ></Route>
            <Route
              path='/products/:category?'
              render={(props) => <Products {...props} />}
            />
            <Route path='/ourstory' component={OurStory} />

            <Route path='/not-found' component={NotFound} />
            <Route exact path='/' component={Home} />
            <Redirect to='/not-found' />
          </Switch>

          <Footer />
        </Router>
      </div>
    );
  }
}

export default Application;
